<template>
  <v-dialog v-model="openMode" max-width="460px" content-class="cdel-dialog" overlay-color="#0d2c6d"
    overlay-opacity="0.55" :persistent="progressShow">
    <v-card class="cdel-card">
      <div class="cdel-body">
        <div class="cdel-icon" aria-hidden="true">
          <v-icon size="28">mdi-delete-alert-outline</v-icon>
        </div>
        <h2 class="cdel-title">למחוק את הקהילה?</h2>
        <p v-if="item && item.name" class="cdel-name">{{ item.name }}</p>
        <p class="cdel-text">{{ detailsText }}</p>
        <p class="cdel-text cdel-text--mute">לא ניתן למחוק קהילה שמשויכים אליה לקוחות.</p>

        <div v-if="errorMessage" class="cdel-error" role="alert">
          <v-icon size="16">mdi-alert-circle-outline</v-icon>
          <span>{{ errorMessage }}</span>
        </div>
      </div>

      <v-progress-linear v-if="progressShow" indeterminate color="#c74747" height="2" />

      <div class="cdel-actions">
        <button type="button" class="cdel-btn cdel-btn--ghost" @click="closeDelete" :disabled="progressShow">ביטול</button>
        <button type="button" class="cdel-btn cdel-btn--danger" @click="deleteItem" :disabled="progressShow">
          <v-icon size="16" color="#fff">mdi-delete-outline</v-icon>
          <span>{{ progressShow ? 'מוחק...' : 'מחק קהילה' }}</span>
        </button>
      </div>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    item: Object,
    value: { type: Boolean, default: false },

  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    errorMessage: "",
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
  }),

  methods: {
    async deleteItem() {
      this.errorMessage = "";
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const myJSON = JSON.stringify({ item: this.item });

        let api = process.env.VUE_APP_BASE_URL + "/communities/delete_community";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", myJSON, token));
        const jsonObject = await res.json();
        this.progressShow = false;
        if (res.status >= 400) {
          this.errorMessage = this.translateError(jsonObject && jsonObject.message);
        } else if (res.status === 200) {
          this.$emit("itemDeleted", this.item, "הקהילה נמחקה בהצלחה!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.progressShow = false;
        this.errorMessage = "שגיאה במחיקת הקהילה: " + error;
      }
    },
    translateError(message) {
      if (!message || typeof message !== "string") {
        return "שגיאה במחיקת הקהילה";
      }
      if (message.includes("being used by customer")) {
        return "לא ניתן למחוק את הקהילה כי משויכים אליה לקוחות";
      }
      return message;
    },
    closeDelete() {
      this.openMode = false;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    detailsText() {
      const count = this.item && Array.isArray(this.item.levels) ? this.item.levels.length : 0;
      if (!count) return "הקהילה תימחק לצמיתות.";
      if (count === 1) return "הקהילה תימחק לצמיתות, יחד עם רמת הסינון שלה.";
      return `הקהילה תימחק לצמיתות, יחד עם ${count} רמות הסינון שלה.`;
    },
  },
}
</script>

<style scoped>
.cdel-card {
  --c-navy: #0d2c6d;
  --c-red: #c74747;
  --c-red-soft: rgba(199, 71, 71, 0.10);
  --c-border: #e3e8ef;
  --c-border-soft: #eef2f7;
  --c-text: #0f172a;
  --c-text-soft: #475569;
  --c-text-mute: #94a3b8;
  --c-ease: cubic-bezier(0.22, 1, 0.36, 1);
  font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
  direction: rtl;
  border-radius: 18px !important;
  overflow: hidden;
}

.cdel-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 26px 18px;
}

.cdel-icon {
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: var(--c-red-soft);
  margin-bottom: 12px;
}
.cdel-icon ::v-deep .v-icon { color: var(--c-red) !important; }

.cdel-title {
  margin: 0 0 4px;
  color: var(--c-text);
  font-size: 1.15rem;
  font-weight: 800;
}

.cdel-name {
  margin: 0 0 10px;
  padding: 3px 12px;
  border-radius: 999px;
  background: rgba(13, 44, 109, 0.07);
  color: var(--c-navy);
  font-size: 0.92rem;
  font-weight: 800;
}

.cdel-text {
  margin: 0 0 4px;
  color: var(--c-text-soft);
  font-size: 0.9rem;
}
.cdel-text--mute {
  color: var(--c-text-mute);
  font-size: 0.82rem;
}

.cdel-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--c-red-soft);
  color: var(--c-red);
  font-size: 0.86rem;
  font-weight: 700;
  text-align: right;
}
.cdel-error ::v-deep .v-icon { color: var(--c-red) !important; }

.cdel-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 14px 20px 18px;
  border-top: 1px solid var(--c-border-soft);
}

.cdel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 120px;
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s var(--c-ease);
}
.cdel-btn:disabled { opacity: 0.55; cursor: default; }

.cdel-btn--ghost {
  background: #ffffff;
  border-color: var(--c-border);
  color: var(--c-text-soft);
}
.cdel-btn--ghost:not(:disabled):hover { background: #f5f7fb; }

.cdel-btn--danger {
  background: var(--c-red);
  color: #fff;
}
.cdel-btn--danger:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px -4px rgba(199, 71, 71, 0.5);
}
</style>

<style>
/* מחוץ ל-scoped כי Vuetify מרנדר את עטיפת הדיאלוג מחוץ לקומפוננטה */
.v-dialog.cdel-dialog {
  border-radius: 18px !important;
  overflow: hidden;
}
</style>